import React from 'react';
import { func, string, shape } from 'prop-types';
import { connect } from 'react-redux';
import toJS from '~/views/enhancers/toJS';


import {
    renderReport,
    exportReport,
} from '~/state/ducks/reports/operations';
import * as s from '~/state/ducks/reports/selectors';

import Reports from '../components/Reports';

class ReportsContainer extends React.Component {
  static propTypes = {
      renderReport: func.isRequired,
      exportReport: func.isRequired,
      match: shape({
          params: shape({
              report: string,
          }).isRequired,
      }).isRequired,
  };

  async componentDidMount() {
      const {
          renderReport,
          match: {
              params: { report },
          },
      } = this.props;

      // Assuming `renderReport` would fetch data from the server, but we'll use mocked data instead
      await this.renderMockedReport(report);
  }

  renderMockedReport = async report =>
  // Simulate an async call to fetch report data
      new Promise((resolve) => {
          setTimeout(() => {
              // Assuming `renderReport` would store the data in the Redux store, but here we'll use mocked data
              resolve();
          }, 1000);
      })
  ;

  handleExport = (e, { value }) => {
      // event is triggered onBlur as well
      if (e.type === 'click') {
      // In a real scenario, you would perform exportReport action,
      // but here we'll just log the exported value for simplicity
          console.log('Exported:', value);
      }
  };

  render = () => <Reports {...this.props} handleExport={this.handleExport} />;
}

const mapStateToProps = state => ({
    isLoading: false, // Assuming the loading state is handled by the async fetch
    isConnecting: false, // Assuming the connecting state is handled by the async fetch
    isExporting: false, // Assuming the exporting state is handled by the export action
});

const mapDispatchToProps = {
    // Assuming renderReport and exportReport are connected to Redux actions
    renderReport: () => {}, // Replace with actual renderReport action if needed
    exportReport: () => {}, // Replace with actual exportReport action if needed
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(ReportsContainer));
